import { useMutation } from "@tanstack/react-query";
import { useFormSuccessNotification, useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import { useInvalidateCarriersQuery } from "./use-carriers-query";
import type { ConditionalRulesEntity, UpdateCarrierDto } from "../generated/schema";

interface UpdateCarrierConditionalRulesParams {
  carrierId: string;
  conditionalRules: ConditionalRulesEntity | null;
}

export function useUpdateCarrierConditionalRules(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateCarriers = useInvalidateCarriersQuery({ shopId });
  const mutation = $api.useMutation("patch", "/shops/{shopId}/carriers/{carrierId}");

  return useMutation({
    mutationFn: async ({ carrierId, conditionalRules }: UpdateCarrierConditionalRulesParams) => {
      return mutation.mutateAsync({
        params: { path: { shopId, carrierId } },
        body: { conditionalRules } as UpdateCarrierDto,
      });
    },
    onSuccess: () => {
      invalidateCarriers();
      successNotification();
    },
    onError: (error) => {
      console.error('Failed to update carrier conditional rules:', error);
      errorNotification();
    },
  });
}
